var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#FFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250,454.91L23.87,190.17,147.79,45.1l102.21,119.67,102.21-119.67,123.91,145.07L250,454.91ZM67.27,190.17l182.73,213.93,182.73-213.93-80.51-94.26-102.21,119.67-102.21-119.67-80.52,94.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.5502ad721686ccf9ec3224dc6a1afb31.svg";
export { ForwardRef as ReactComponent };